/**
 * Course discussion list.
 */
import React from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { BEmpty, BGPagination } from "components";
import { useAsterController } from "context";
import { actionCommentList } from "context/action";
import { VText } from "form";
import CourseCommentItem from "./course.comment.item";

/**
 * Lists and composes course comments.
 */
const CourseComment = () => {
  const { t } = useTranslation("common");

  const { courseId } = useParams();

  const [controller, dispatch] = useAsterController();
  const { comments } = controller;

  const handlePageChange = (page, pageSize) => actionCommentList(dispatch, { course_id: courseId, discussion_id: "", page, page_size: pageSize });

  return (
    <>
      <Box>
        <Box className="w-full md:flex hidden justify-center sm:justify-start">
          <VText className="text-2xl font-bold">{t("Comments")}</VText>
        </Box>
        {
          comments.data?.length ? (
            <Box className="w-full my-5">
              {(comments.data || []).map((comment) => (
                <CourseCommentItem key={comment._id} comment={comment} />
              ))}
              <BGPagination handlePageChange={handlePageChange} total={comments.total} initPage={comments.page} initSize={comments.page_size} />
            </Box>
          ) :
          <BEmpty />
        }
      </Box>
    </>
  );
};

export default CourseComment;
